import { useState, useEffect } from 'react';
import { useJhaTemplate, useUpdateJhaTemplate } from '../../hooks/useJha.js';
import { useError } from '../../components/shared/ErrorBanner.jsx';

export default function JhaTemplatePage() {
  const { data: tpl } = useJhaTemplate();
  const update = useUpdateJhaTemplate();
  const { show } = useError();

  const [name, setName] = useState('Daily JHA');
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (tpl) {
      setName(tpl.name || 'Daily JHA');
      setQuestions(tpl.questions || []);
    }
  }, [tpl]);

  const updateQ = (i, patch) => setQuestions(qs => qs.map((q, idx) => idx === i ? { ...q, ...patch } : q));
  const remove = (i) => setQuestions(qs => qs.filter((_, idx) => idx !== i));
  const add = () => setQuestions(qs => [...qs, { id: 'q' + Date.now(), text: '', type: 'yesno', required: true }]);
  const move = (i, dir) => setQuestions(qs => {
    const next = qs.slice();
    const j = i + dir;
    if (j < 0 || j >= next.length) return qs;
    [next[i], next[j]] = [next[j], next[i]];
    return next;
  });

  const save = async () => {
    try { await update.mutateAsync({ name, questions }); }
    catch (err) { show(err.message); }
  };

  return (
    <div>
      <div className="banner info">
        Current version: <strong>{tpl?.version ?? '—'}</strong>. Saving creates a new version; past submissions remain tied to their original.
      </div>
      <div className="field">
        <label className="field-label">Name</label>
        <input className="field-input" value={name} onChange={e => setName(e.target.value)} />
      </div>
      {questions.map((q, i) => (
        <div key={q.id} className="jha-question-card">
          <div className="jha-question-row">
            <div className="field jha-q-type">
              <label className="field-label">Type</label>
              <select className="field-select" value={q.type} onChange={e => updateQ(i, { type: e.target.value })}>
                <option value="yesno">Yes/No</option>
                <option value="text">Text</option>
                <option value="ack">Acknowledge</option>
                <option value="choice">Choice</option>
              </select>
            </div>
            <div className="field jha-q-text">
              <label className="field-label">Question text</label>
              <input className="field-input" value={q.text} onChange={e => updateQ(i, { text: e.target.value })} />
            </div>
            <label className="jha-q-req">
              <input type="checkbox" checked={q.required}
                onChange={e => updateQ(i, { required: e.target.checked })} /> req
            </label>
            <div className="jha-q-move">
              <button className="btn-sm" type="button" onClick={() => move(i, -1)} aria-label="Move up">↑</button>
              <button className="btn-sm" type="button" onClick={() => move(i, 1)} aria-label="Move down">↓</button>
            </div>
            <button className="btn-sm jha-q-del" type="button" onClick={() => remove(i)} aria-label="Remove question">×</button>
          </div>
          {q.type === 'choice' && (
            <div className="field" style={{ marginTop: 8, marginBottom: 0 }}>
              <label className="field-label">Options (comma-separated)</label>
              <input className="field-input"
                value={(q.options || []).join(', ')}
                onChange={e => updateQ(i, { options: e.target.value.split(',').map(s => s.trim()).filter(Boolean) })} />
            </div>
          )}
        </div>
      ))}
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button className="btn-sm" onClick={add}>+ Add question</button>
        <button className="btn-sm primary" onClick={save} disabled={update.isPending}>
          {update.isPending ? 'Saving…' : 'Save as new version'}
        </button>
      </div>
    </div>
  );
}
